<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
            <el-form-item v-if="pid" label="父级菜单" prop="parentMenuId">
                <el-select v-model="form.parentMenuId">
                    <el-option v-for="item in menus" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="菜单名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <el-select v-model="form.type">
                    <el-option value="0" label="目录"></el-option>
                    <el-option value="1" label="菜单"></el-option>
                    <el-option value="2" label="按钮"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
                <Uploader v-model="form.icon"></Uploader>
            </el-form-item>
            <el-form-item label="路由" prop="route">
                <el-input v-model="form.route" placeholder="请输入菜单路由"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input-number v-model="form.sort" placeholder="请输入菜单排序" style="width: 200px"></el-input-number>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch v-model="form.status"></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Uploader from "@/components/Uploader.vue";
import { add, edit, detail, list } from "@/api/permission/menu";
export default {
    components: { Uploader },
    data() {
        return {
            id: null,
            pid: null,
            menus: [],
            form: {
                parentMenuId: null,
                name: "",
                type: "",
                icon: "",
                route: "",
                sort: 0,
                status: true
            },
            rules: {
                name: [{ required: true, message: '请输入菜单名称' }],
                type: [{ required: true, message: '请选择菜单类型' }],
                route: [{ required: true, message: '请输入菜单路由' }],
                sort: [{ required: true, message: '请输入菜单排序' }],
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.pid = this.$route.query.pid;
        if (this.id) {
            this.getDetail();
        }
        if (this.pid) {
            this.form.parentMenuId = +this.pid ;
            this.getList();
        }
    },
    methods: {
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = { ...data, status: data.status == 1, type: data.type + '' };
                }
            })
        },
        getList() {
            list().then(({ code, message, data }) => {
                if (code == 200) {
                    this.menus = data;
                } else {
                    this.$message.error(message);
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    status: this.form.status ? 1 : 0
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>